var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content-wrappper" }, [
    _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-8 col-sm-3 col-xs-12" },
          [
            _c(
              "router-link",
              {
                staticClass: "tools-text sub_heading",
                attrs: { to: "/layout/prodclassification" },
              },
              [_c("i", { staticClass: "fa fa-angle-left" })]
            ),
            _c("span", { staticClass: "heading" }, [
              _vm._v(
                "Please provide data to start Regulatory Pathway for your medical device :"
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4 col-sm-3 col-xs-12" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.picked,
                expression: "picked",
              },
            ],
            attrs: {
              type: "radio",
              id: "one",
              value: "DeviceAlreadyClassified",
            },
            domProps: {
              checked: _vm._q(_vm.picked, "DeviceAlreadyClassified"),
            },
            on: {
              change: function ($event) {
                _vm.picked = "DeviceAlreadyClassified"
              },
            },
          }),
          _c("label", { attrs: { for: "one" } }, [_vm._v("Yes")]),
        ]),
        _c("div", { staticClass: "col-md-4 col-sm-3 col-xs-12" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.picked,
                expression: "picked",
              },
            ],
            attrs: {
              type: "radio",
              id: "two",
              value: "PurchaseRRFromDashboard",
            },
            domProps: {
              checked: _vm._q(_vm.picked, "PurchaseRRFromDashboard"),
            },
            on: {
              change: function ($event) {
                _vm.picked = "PurchaseRRFromDashboard"
              },
            },
          }),
          _c("label", { attrs: { for: "two" } }, [_vm._v("No")]),
        ]),
      ]),
      _vm.picked === "DeviceAlreadyClassified"
        ? _c("div", { staticClass: "tool-container" }, [
            _c(
              "div",
              { staticClass: "tool-510k col-md-4 col-xs-12 col-sm-12" },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/layout/prodclassification-home" } },
                  [
                    _c("div", { staticClass: "tool-text" }, [
                      _c("p", { staticClass: "main-content" }, [
                        _vm._v(
                          " Please provide all the required details for Regulatory pathway by continuing here. "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.picked === "PurchaseRRFromDashboard"
        ? _c("span", [
            _vm.picked === "PurchaseRRFromDashboard"
              ? _c("div", { staticClass: "tool-container" }, [
                  _c(
                    "div",
                    { staticClass: "tool-510k col-md-4 col-xs-12 col-sm-12" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: "/layout/prodclassification-regpathway-home",
                          },
                        },
                        [
                          _c("div", { staticClass: "tool-text" }, [
                            _c("p", { staticClass: "main-content" }, [
                              _vm._v(
                                " Start with a new New Classifcation Here "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.picked === "PurchaseRRFromDashboard" && false
              ? _c(
                  "div",
                  {
                    staticClass: "tool-container",
                    on: { click: _vm.simpleMethod },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "tool-510k col-md-4 col-xs-12 col-sm-12" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: "" },
                            on: { click: _vm.simpleMethod },
                          },
                          [
                            _c("div", { staticClass: "tool-text" }, [
                              _c("p", { staticClass: "main-content" }, [
                                _vm._v(
                                  " Completed Classification - Select from your saved classificaiton below. "
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.picked === "PurchaseRRFromDashboard" && _vm.displayFlag
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _c("product-classification-history-requests", {
                attrs: { userIdLoggedIn: _vm.userId },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8 col-sm-3 col-xs-12" }, [
        _c("p", { staticClass: "sub_caption" }, [
          _vm._v("Is your medical device already classified? "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }